import {
  chakra,
  Box,
  VStack,
  Link,
  Flex,
  Image,
  Button,
} from "@chakra-ui/react";

const LandingPageContainer = chakra(Box, {
  baseStyle: {
    position: "relative",
    left: "0",
    height: "auto",
    boxShadow: "md",
    transition: "width 0.3s",
    border: "1px solid",
    borderColor: "gray.400",
    marginBottom: "32px",
  },
});

const ButtonInToggle = chakra(Button, {
  baseStyle: {
    height: "64px",
    backgroundColor: "#F1F6F9",
    color: "gray.700",
    borderRadius: "16",
    width: "auto",
    margin: "16px 32px",
    fontWeight: 400,
  },
});

const StyledLink = chakra(Link, {
  baseStyle: {
    py: "2",
    display: "flex",
    textDecoration: "none",
    width: "300px",
    color: "inherit",
    margin: "8px 0",
    whiteSpace: "nowrap",
  },
  image: {
    marginRight: "8px",
  },
});

const StyledVStack = chakra(VStack, {
  baseStyle: {
    // mt: "250px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align items at the start of the container
    // height: "100%", // Ensure the VStack takes up the full height
    justifyContent: "space-between",
    padding: "32px",
  },
});

const MainContentContainer = chakra(Box, {
  baseStyle: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    transition: "margin-left 0.3s",
  },
});

const HeaderContainer = chakra(Box, {
  baseStyle: {
    bg: "white",
    px: "4",
    py: "2",
    shadow: "sm",
  },
});

const HeaderFlex = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const LogoImage = chakra(Image, {
  baseStyle: {
    width: "168px",
    height: "46px",
  },
});

const ContentBox = chakra(Box, {
  baseStyle: {
    flex: "1",
    p: "4",
  },
});

export const DashboardLayoutContainter = chakra(Box, {
  baseStyle: {
    background: "white",
    h: "100vh",
    width: "100%",
    overflow: "hidden",
    display: "flex",
  },
});

export const StyledAdminLayout = chakra(Box, {
  baseStyle: {
    bg: "theme.bg.box",
    h: "100vh",
    width: "100%",
    overflow: "hidden",
    display: "flex",
  },
});

export const StyledSuperAdminLayout = chakra(Box, {
  baseStyle: {
    bg: "theme.bg.box",
    h: "100vh",
    width: "100%",
    overflow: "hidden",
    display: "flex",
  },
});

export {
  LandingPageContainer,
  ButtonInToggle,
  StyledLink,
  StyledVStack,
  MainContentContainer,
  HeaderContainer,
  HeaderFlex,
  LogoImage,
  ContentBox,
};
